import { RiPlayCircleLine } from '@remixicon/react';

import {
  type ToolGroupEntry,
  createToolExtension,
  mcpTool,
} from '@spotify/plugin-confidence-chat-react';

import { recordingsPlugin } from '../plugin';
import { RecordingsResult } from './RecordingsResult';
import { parseSearchResult } from './searchResult';

const MAX_RECORDINGS = 10;

export const RecordingToolFallback = ({ entry }: { entry: ToolGroupEntry }) => {
  const result = parseSearchResult(entry.result?.content);
  if (!result || result.presentation === 'block') {
    return null;
  }

  return (
    <RecordingsResult recordings={result.recordings.slice(0, MAX_RECORDINGS)} />
  );
};

export const RecordingToolExtension = recordingsPlugin.provide(
  createToolExtension({
    id: 'recording-preview',
    predicate: mcpTool('semantic_search_recordings'),
    icon: RiPlayCircleLine,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <RecordingToolFallback entry={entry} />,
  }),
);
